import { SvgIcon } from "@mui/material";

const ExpandLessIcon = () => {
  return (
    <SvgIcon
      style={{ transform: "scale(0.6)" }}
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="green"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99972 0.999969C8.23338 0.999512 8.45981 1.08089 8.63972 1.22997L14.6397 6.22997C14.8439 6.39971 14.9724 6.64362 14.9967 6.90804C15.0211 7.17247 14.9395 7.43575 14.7697 7.63997C14.6 7.84419 14.3561 7.97261 14.0916 7.99699C13.8272 8.02137 13.5639 7.93971 13.3597 7.76997L7.99972 3.28997L2.63972 7.60997C2.53744 7.69303 2.41974 7.75507 2.2934 7.7925C2.16706 7.82993 2.03457 7.84202 1.90354 7.82808C1.77251 7.81414 1.64553 7.77445 1.52989 7.71127C1.41426 7.6481 1.31225 7.5627 1.22972 7.45997C1.13814 7.35715 1.06878 7.23652 1.02599 7.10565C0.9832 6.97477 0.967897 6.83647 0.98104 6.69941C0.994183 6.56235 1.03549 6.42947 1.10237 6.30912C1.16926 6.18876 1.26027 6.08351 1.36973 5.99997L7.36972 1.16997C7.55481 1.04445 7.77662 0.984598 7.99972 0.999969Z"
        fill="#1062D0"
      />
    </SvgIcon>
  );
};

export default ExpandLessIcon;
